import { FC, useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ACCEPTED_PRECERT_FILE_EXTENSIONS, MAX_FILE_SIZE } from "src/constants";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";
import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import AuthSubHeader from "../../components/authSubHeader";
import FooterText from "../../components/footerText";



const CopayClaim: FC = (): JSX.Element => {
  const [uploadFile, changeUploadFile] = useState<FileList | null>(null)
  const [uploadClaimForm, changeUploadClaimForm] = useState<FileList | null>(null)
  const [shouldSubmitToWarehouse, updateSubmitValue] = useState<boolean>(true)
  const [copayFormError, updateCopayFormError] = useState<string>("")
  const [claimFormError, updateClaimFormError] = useState<string>("")

  const { caseId } = useParams();
  const ref = useRef<HTMLInputElement>(null);
  const claimFormRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate()
  const { showToast } = useContext(ToastContext)

  const clearDataAndForm = () => {
    changeUploadFile(null)
    updateCopayFormError("")
    if (ref.current)
      ref.current.value = ""
  }

  const clearClaimForm = () => {
    changeUploadClaimForm(null)
    updateClaimFormError("")
    if (claimFormRef.current)
      claimFormRef.current.value = ""
  }



  const { loading: isFileUploading, data: uploadCopayResponse, mutate: uploadCopayProgram } =
    useFetch(APIEndpoints.COPAY_CLAIM);

  useEffect(() => {
    if (uploadCopayResponse) {
      showToast(["Your co-pay claim has been forwarded to FlexForward"], ToastTypes.SUCCESS)
      clearDataAndForm()
      clearClaimForm()
      navigate(-1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadCopayResponse])

  const submitCopayForm = () => {
    if (uploadFile) {
      updateClaimFormError("")
      const copay_body = new FormData()
      copay_body.append('eob_document', uploadFile[0])
      copay_body.append('case_id', caseId || "")
      copay_body.append('status', 'new')
      copay_body.append('eob_warehouse', shouldSubmitToWarehouse ? 'true' : 'false')
      copay_body.append('source', 'from_copay')
      if (uploadClaimForm) {
        copay_body.append('claim_form', uploadClaimForm[0])
      }
      // setLoader();
      uploadCopayProgram(copay_body);
    } else {
      updateCopayFormError("Please upload EOB/EOP file")
    }
  }



  const uploadFileAfterValidation = (file: FileList | null) => {
    if (!file) return
    if (file[0].size > MAX_FILE_SIZE) {
      updateCopayFormError("File size is more than 25MB")
      if (ref.current)
        ref.current.value = ""
      return;
    }
    if (!Object.values(ACCEPTED_PRECERT_FILE_EXTENSIONS).includes(file[0].type)) {
      updateCopayFormError("File type is not one of the accepted file types")
      if (ref.current)
        ref.current.value = ""
      return;
    }

    changeUploadFile(file)
    updateCopayFormError("")
  }

  const uploadClaimFormAfterValidation = (file: FileList | null) => {
    if (!file) return
    if (file[0].size > MAX_FILE_SIZE) {
      updateClaimFormError("File size is more than 25MB")
      if (claimFormRef.current)
        claimFormRef.current.value = ""
      return;
    }
    if (!Object.values(ACCEPTED_PRECERT_FILE_EXTENSIONS).includes(file[0].type)) {
      updateClaimFormError("File type is not one of the accepted file types")
      if (claimFormRef.current)
        claimFormRef.current.value = ""
      return;
    }

    changeUploadClaimForm(file)
    updateClaimFormError("")
  }


  return (
    <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
      <div className="bg-mist py-2">
        <div className="container-fluid">
          <AuthSubHeader />
        </div>
      </div>
      <div className="container-fluid pt-2 d-flex flex-column flex-fill">
        <h2 className="m-0 page-heading">Upload Co-Pay Documents </h2>
        {/* {process.env.REACT_APP_ENV === 'staging' && (<br />  Filing a ZILRETTA Co-Pay claim is quick and easy! There are 2 ways your practice can file a claim:
            <ol>
              <li>
                <b>Directly/electronically through your billing software’s workflow via Electronic Data Interchange- </b>
                simply send a secondary claim to payer ID PSKW0. For more information on the
                electronic claims process including how to set up your practice 
                <a href="/pages/instruction/claim" target="_blank" rel="noreferrer"> click here</a>
                <br />)
                OR
              </li>
              <li>
                <b>Uploading the EOB/EOP to the FlexForward Portal.</b>
                Once you receive the  Explanation of Benefit or Payment (EOB/EOP) from the patient’s insurance upload
                it and the submitted claim (CMS 1500 or UB04) below.  Please allow 8-15 business days for reimbursement
                after submitting co-pay claim to FlexForward.
              </li>
            </ol>} */}

        <>
         {process.env.REACT_APP_ENV === "staging" ? <p>
            Filing a ZILRETTA Co-Pay claim is quick and easy! There are 2 ways your
            practice can file a claim:
          </p>
          : <p>
            Filing a ZILRETTA Co-Pay claim is quick and easy!
          </p>}
          <ol>
            {process.env.REACT_APP_ENV === "staging" && <li>
              <b>
                Directly/electronically through your billing software’s workflow via
                Electronic Data Interchange —
              </b>{" "}
              simply send a secondary claim to payer ID PSKW0. For more information on
              the electronic claims process including how to set up your practice,{" "}
              <a href="/pages/instruction/claim" target="_blank" rel="noreferrer">
                click here
              </a>
              .
              <br />
              <b>OR</b>
            </li>}

            <li>
              <b>Uploading the EOB/EOP to the FlexForward Portal.</b> Once you receive
              the Explanation of Benefit or Payment (EOB/EOP) from the patient’s
              insurance, upload it and the submitted claim (CMS 1500 or UB04) below.
              Please allow 8–15 business days for reimbursement after submitting the
              co-pay claim to FlexForward.
            </li>
          </ol>
        </>


        <div className="card mt-3">
          <div className="card-body">

            <div className="mb-3">
              <div className="input-group mb-2 gap-2">
                <label className="form-label mb-0 fw-normal" style={{ fontFamily: 'sans-serif' }}>
                  EOB/EOP *
                </label>
                <input
                  type="file" className="form-control w-auto" id="fileUpload"
                  onChange={(e) => uploadFileAfterValidation(e.target.files)} ref={ref}
                  disabled={isFileUploading}
                />
                {uploadFile ? (
                  <button
                    className="btn btn-primary" onClick={clearDataAndForm} type="button"
                    id="fileUpload" disabled={isFileUploading}
                  >
                    Clear
                  </button>
                ) : null}
              </div>
              {copayFormError ? (
                <small className="d-block mb-2 text-danger">
                  <i className="bi bi-exclamation-circle"></i>{' '}
                  {copayFormError}
                </small>
              ) : null}
              <small className="d-block">
                Click here to upload the EOB or EOP form. Currently we accept .txt, .pdf, .tiff, .doc, .ccd, .cda,
                .ccr, .ccda and image files.
              </small>
              <span className="d-block text-black fst-italic" style={{ fontSize: 12 }}>*Maximum 25 MB file size is allowed</span>
            </div>
            <div className="mb-3">
              <div className="input-group mb-2 gap-2">
                <label className="form-label mb-0 fw-normal" style={{ fontFamily: 'sans-serif' }}>
                  CMS 1500 / UB-04 Claim Form
                </label>
                <input
                  type="file" className="form-control w-auto" id="fileUpload"
                  onChange={(e) => uploadClaimFormAfterValidation(e.target.files)} ref={claimFormRef}
                  disabled={isFileUploading}
                />
                {uploadClaimForm ? (
                  <button
                    className="btn btn-primary" onClick={clearClaimForm} type="button"
                    id="fileUpload" disabled={isFileUploading}
                  >
                    Clear
                  </button>
                ) : null}
              </div>
              {claimFormError ? (
                <small className="d-block mb-2 text-danger">
                  <i className="bi bi-exclamation-circle"></i>{' '}
                  {claimFormError}
                </small>
              ) : null}
              <small className="d-block">
                Click here to upload the CMS 1500 or UB-04 claim form. Currently we accept .txt, .pdf, .tiff, .doc, .ccd, .cda,
                .ccr, .ccda and image files.
              </small>
              <span className="d-block text-black fst-italic" style={{ fontSize: 12 }}>*Maximum 25 MB file size is allowed</span>
            </div>
            <div className="bg-light">
              <div className="form-check">
                <input
                  className="form-check-input" type="checkbox"
                  id="flexCheckIndeterminateDisabled"
                  checked={shouldSubmitToWarehouse}
                  disabled={isFileUploading}
                  onChange={(e) => {
                    updateSubmitValue(e.target.checked)
                  }}
                />
                <label className="form-check-label" htmlFor="flexCheckIndeterminateDisabled">
                  By clicking this box, I agree to have a redacted copy of the patient’s EOB/EOP shared to the FlexForward EOB warehouse.
                </label>
              </div>
              <p className="m-0 text-body-secondary">
                Please allow 8-15 days for reimbursement after submitting co-pay claim to FlexForward. Please contact
                FlexForward on any specific co-pay claim/case questions
              </p>
            </div>
            <div className="mt-3">
              <button
                type="button" disabled={isFileUploading}
                className="btn btn-primary"
                onClick={submitCopayForm}
              >
                {isFileUploading ? (
                  <i className="spinner-border text-white me-2" style={{ width: `24px`, height: `24px` }}></i>
                ) : null}
                <p className="col-auto mb-0">Upload</p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <FooterText footerType="black" />
    </div>
  )
}

export default CopayClaim
